import { render } from "./DistributorView.vue?vue&type=template&id=2573d86c&ts=true"
import script from "./DistributorView.vue?vue&type=script&lang=ts"
export * from "./DistributorView.vue?vue&type=script&lang=ts"

import exportComponent from "/home/runner/work/dashboard/dashboard/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__